import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useUpdateProfile() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function updateProfile(data) {
    return privateFetch.put(`/v1/me`, data);
  }

  return useMutation(updateProfile, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('ME');
    },
  });
}

export default useUpdateProfile;
